export default "__VITE_ASSET__VQj__Ai2__"